export const SpecialCharsRegex = {
  Strict: /^[A-Za-z0-9 ]*$/g,
  Loose: /^[A-Za-z0-9,.'\- ]*$/g,
}

export const hasSpecialChars = (
  values: string[],
  pattern: RegExp = SpecialCharsRegex.Strict
): boolean => {
  return values.some(s => !s.match(pattern))
}

export const hasFewerWordsThan = (
  values: string[],
  wordCount: number
): boolean => {
  return values.some(s => s.trim().split(' ').length < wordCount)
}

export const capitalizeWord = (string: string): string =>
  `${string.charAt(0).toUpperCase()}${string.slice(1)}`

export const hasWhiteSpace = (str: string) => {
  return str.indexOf(' ') >= 0
}

export const toSnakeCase = (string: string) =>
  string
    .replace(/\W+/g, ' ')
    .split(/ |\B(?=[A-Z])/)
    .map(word => word.toLowerCase())
    .join('_')

export const stripHtml = (string: string) => string.replace(/<(.|\n)*?>/g, '')

export const generateUID = () => {
  let firstPart = String((Math.random() * 46656) | 0)
  let secondPart = String((Math.random() * 46656) | 0)
  firstPart = ('000' + firstPart).slice(-3)
  secondPart = ('000' + secondPart).slice(-3)

  return firstPart + secondPart
}
export const hasNumber = (str: string) => {
  return /\d/.test(str)
}

export const escapeRegExp = (string: string) => {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}

export const isValidUrl = (value: string): boolean => {
  if (!value) return true

  const trimmed = value.trim()

  if (/\s/.test(trimmed)) return false

  const urlString = /^https?:\/\//i.test(trimmed)
    ? trimmed
    : `http://${trimmed}`

  try {
    const url = new URL(urlString)
    if (!['http:', 'https:'].includes(url.protocol)) return false

    const host = url.hostname.toLowerCase()
    if (
      /^\d{1,3}(\.\d{1,3}){3}$/.test(host) ||
      /^\[.*:.*]$/.test(host) ||
      host === 'localhost'
    ) {
      return true
    }

    if (!host.includes('.')) return false

    const tld = host.split('.').pop()!
    if (!/^[a-z]{2,63}$/i.test(tld)) return false

    return true
  } catch {
    return false
  }
}

export const validateMinCharCount = (newTitle: string, min: number) => {
  const notOverMin = newTitle ? newTitle.length < min : false
  const errors = []

  if (notOverMin) {
    errors.push('portfolio.min_characters')
  }

  const valid = !notOverMin

  return {
    valid,
    message: errors.join(', '),
  }
}
